import { FORWARD_ENVIROMENTS } from "../constants"

export default {
    name: 'ForwardDialogComponent',
    components: {
    },
    props: {
        // v-model injects the object to be edited into props.value
        showCreateEditDialog: {
            type: Boolean,
            required: false,
            default: false
        },
        model: {
            type: Object,
            required: false,
            default: () => { return { unitId: "", urls: new Set() } }
        }
    },
    data: () => ({
        environments: Object.values(FORWARD_ENVIROMENTS),
        environmentSelected: null,
        customUrl: "",
        // table
        tableDataKey: "key",
        tableHeaders: [],
        tableFilterRules: [],
        tableData: [],
        tableActions: [],
        rowActions: [],
        loading: false,
        urls: new Set()
    }),
    computed: {
    },
    created() {
    },
    mounted() {
        this.urls = new Set(this.model.urlsSet);
    },
    beforeDestroy() {
    },
    methods: {
        updateMode() {
            this.model.urlsSet = this.urls;
        },
        deleteUrls(urlFilter) {
            this.urls.delete(urlFilter);
            this.urls = new Set(this.urls);
            console.log(this.urls, urlFilter);
        },
        refreshTable: () => {
        },
        addServer() {
            if (this.environmentSelected) {
                let url = null;
                if (this.environmentSelected === 'CUSTOM') {
                    url = this.customUrl;
                } else {
                    url = FORWARD_ENVIROMENTS[this.environmentSelected].URL;
                }
                this.urls.add(url);
                this.urls = new Set(this.urls);
            }
        }
    }
}